import $ from 'jquery';
import _ from 'lodash';
import constants from 'Constants';
import { View } from 'backbone';
import { Model } from 'backbone';
import pageCollection from 'PageCollection'
import pageSyncService from 'PageSyncService';
import listService from 'ListService';
import pageCaptureController from 'PageCaptureController';
import ThumbPageView from 'designer/MobileThumbPageItemView';
import ThumbPageBehaviorsOnlyView from 'designer/MobileThumbPageBehaviorsOnlyView';
import template from 'designer/mobile-thumb-page-list.ejs';
import stageDropdown from 'designer/stages-dropdown.ejs';
import rolesDropdown from 'designer/roles-dropdown.ejs';
import columnsDropdown from 'designer/mobile-columns-dropdown.ejs';
import Spinner from 'spin/spin';
import eventBus from 'EventBus';
import InputsByStageAndRole from 'common-views/InputsByStageAndRole';
import settingsService from 'MandatoryAndStateSettingsService';
import toolboxItemMapService from 'ToolboxItemMapService';
import pageTemplate from 'common-views/select-field/select-field-page.ejs';
import controlWithValuesTemplate from 'common-views/select-field/select-field-control-with-values.ejs';
import controlTemplate from 'common-views/select-field/select-field-control.ejs';
import behaviorHelperService from 'BehaviorHelperService.js';
import undoService      from 'UndoService.js';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import util from 'util/Util.js';
import BreadCrumbView from 'BreadCrumbView.js';
import viewManagerService from 'ViewManagerService';
import mobileListService from 'mobile/MobileListService';

import SimpleConfirmModal from 'common-views/SimpleConfirmModalView.js';
import NotificationService from 'NotificationService.js';

import mobileConstants from "../../mobile/commons/MobileFormsConstants";


import MobileLeftPanelButton from  '../../components/MobileWizard/MobileLeftPanelButton';


import React, { Component, useRef} from "react";
import { createRoot } from "react-dom/client";
import notificationService from '../../service/NotificationService';
import LeftPanelStateService from '../../service/LeftPanelStateService';


const SILENT = constants.MODEL_SILENT;

//=========================================================
// This is a view on a collection of per-page control items
//=========================================================
class MobileThumbPageListView extends View {
    initialize(opts) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.selectedType = '';
        this.model.set('isForm', listService.docType === constants.DOC_TYPE_FORM, SILENT);

        // TODO - Compile list of Names (Pages, Objects and Behavior Commands)
        // Page 1
        // Page 1/Text 1
        // Page 1/Text 1/Submit Data
        /*
        this.searchableItems = [
            {   name:'Text 1', factoryKey: '', icon: '', displayName: 'Page 1/Text 1'},
            {   name:'Submit Data', factoryKey: '', icon: '', displayName: 'Page 1/Text 1/Submit Data'},
            {   name:'Page 1', factoryKey: '', icon: '', displayName: 'Page 1'}];
            */

        // BB collection of page items (thumbnail item views + decorations for controls of each)

        this.events = {
            'click .document-heading': 'thumbnailClickListener',
            'click .select-stage': 'updateCurrentStage',
            'click .select-role': 'updateCurrentRole',
            'click .select-column': 'updateCurrentColumnView',
            'click #view-state-modal': 'viewStateModal',
            'click #view-mandatory-modal': 'viewMandatoryModal',
            'click .select-filter': 'selectFilter',
            'click  #right-rail .switch': 'handleDocumentSwitch',
            'click .control-form-items': 'switchCollapsibleItems',
            'click #thumb-pages .document-heading a.switch': 'toggleIcon',
            'click .document .document-heading[data-toggle="collapse"]': 'toggleIcon'
        };

        this.searchableItems = listService.getSearchableItems();
        this.collection = pageCollection;
        //        this.collection.comparator = 'timestamp';
        this.model.set('helpUrl', constants.HELP_GENERAL_URL);
        this.model.set('sectionTitle', listService.docType === constants.DOC_TYPE_FORM ? "App" : listService.docType, SILENT);


        // Need this for when we switch layouts.
        if (!listService.loading) {
            this.establishPageListener();
        }

        this.formLoadCompleted = () => {
            this.establishPageListener();
        };


        // Wait for form to finish loading, then render
        this.listenTo(eventBus, constants.EV_FORM_LOADED, this.formLoadCompleted);
        this.listenTo(eventBus, constants.EV_ROLE_OR_STAGE_UPDATED, this.updateStageAndRoles );
        this.listenTo(eventBus, constants.EV_REFRESH_REMOTE_DATA_FILTER, this.refreshSearchableItems );
        this.listenTo(eventBus, constants.EV_SELECT_OBJECT, this.selectObject);
        this.listenTo(eventBus, constants.EV_UPDATE_BEHAVIORS_ONLY, this.openBehaviorsOnly);

        if (!util.hasEventListener(eventBus._events, mobileConstants.CREATE_DRAGGABLE_SECTION)) {
            this.listenTo(eventBus, mobileConstants.CREATE_DRAGGABLE_SECTION, this.createDraggableSections);
        }

        if (!util.hasEventListener(eventBus._events, mobileConstants.CREATE_DRAGGABLE_MOBILE_CONTROLS)) {
            this.listenTo(eventBus, mobileConstants.CREATE_DRAGGABLE_MOBILE_CONTROLS, this.createDraggableMobileControls);
        }

        $(document).on(constants.EV_PAGE_OBJECTS_UPDATED, this.updatePageObjects.bind(this));
        $(document).on(constants.EV_PAGE_COMMANDS_UPDATED, this.updatePageCommands.bind(this));
        $(document).on(constants.EV_PAGE_DELETE_CURRENT, this.pageDeleteCurrent.bind(this));


        if (!this.model.get('filterList')) {
            let list = toolboxItemMapService.getMobileControls();
            let fl = toolboxItemMapService.getLayoutItemsByGroup('all');
            _.forEach(fl, (f) => {
                list.push({ name: f.name, id: f.factoryKey, type: 'object' });
            });

            let flCommands = toolboxItemMapService.getBehaviorItemsByGroup('all');
            _.forEach(flCommands, (f) => {
                list.push({ name: f.name, id: f.factoryKey, type: 'command' });
            });

          
           this.model.set('filterList', list, { silent: true });
        }

        this.triggerDialog = false;

        return this;
    }

    initBreadcrumb() {
        this.breadCrumbView = new BreadCrumbView({
            //mode:this.model.get('mode'),
            mode: listService.mainKind,
            el: this.$el.find('.left-breadcrumb')
        });

        viewManagerService.renderBreadcrumbView(this.breadCrumbView, true); 
    }


    toggleIcon(e) {
        const target = e.currentTarget.getAttribute('data-target');
        const self = $(e.currentTarget);
        const icon = self.find('i');
        let collapsedIcon = 'pf-carot-left';

        if(target.indexOf("objects-page-group") > -1){
            collapsedIcon = 'pf-carot-left pf-rotate-icon';
        }

        if (icon.length) {
            util.togglePanel(self,icon, collapsedIcon);
        }
    }

    switchCollapsibleItems(e) {

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let isCollapsed = e.target.id === "collapseAll";
        
        let collapsibleIcons = $(".document-group .document-heading > .switch > i:not(.form-expandable)");
        let collapsibleDocuments = $(".document-group .document-body:not(#well01)");
        let collapseEffect = "show";
        let addIconClass = "pf-carot-down";
        let removeIconClass = "pf-carot-left";

        if (isCollapsed) {
            collapseEffect = 'hide';
            addIconClass = "pf-carot-left";
            removeIconClass = "pf-carot-down";         
        }
    
        collapsibleDocuments.collapse(collapseEffect); 
        collapsibleIcons.removeClass(removeIconClass)
                        .addClass(addIconClass);
    } 

    remove() {
        this.undelegateEvents();
        this.stopListening();

        $('li.object-selector').off();
        $('li.behavior-selector').off();
        $('#searchLeftPanel').typeahead('destroy').off();


        $(document).off(constants.EV_PAGES_UPDATED, this.pageListener);
        $(document).off(constants.EV_FORM_LOADED, this.formLoadCompleted);

        $(document).off(constants.EV_PAGE_OBJECTS_UPDATED);
        $(document).off(constants.EV_PAGE_COMMANDS_UPDATED);
        $(document).off(constants.EV_PAGE_DELETE_CURRENT);
        
        this.$el.empty();
        
        super.remove();
    }

    establishPageListener() {
        this.pageListener = evt => {
            this.render();
        };
        this.listenTo(eventBus, constants.EV_PAGES_UPDATED, this.pageListener);
    }

    //============================================================================
    // Remove page from BB collection of pages used to render thumbnails
    //============================================================================
    pageDeleteCurrent() {
        const pageId = listService.currentPageId;
        if (pageId) {
            const model = this.collection.get(pageId);
            this.collection.remove(model);
        }
    }

    selectFilter(e) {
        e.preventDefault();
        const selectedFilter = e.currentTarget.getAttribute('data-id');
        this.selectedType = e.currentTarget.getAttribute('data-type-id');
        // find all objects matching filter

        let pageObjects = [];
        if (this.selectedType === 'object') {
            let inputFilter = (control) => {
                return (control !== undefined && control.groupId === undefined && control.model.get('factoryKey') === selectedFilter);
            };
            pageObjects = listService.getAllControlsByPageList(inputFilter, false);
        }

        if (this.selectedType === 'command') {
            let inputFilter = (control) => {
                return (control !== undefined && control.model.get('factoryKey') === selectedFilter);
            };
            // get all Commands associated by Page
            pageObjects = listService.getBehaviorInstanceObjectsByPageList(inputFilter)
        }

        let hasResults = false;
        $('#filterResults').empty();
        $('#filterResults').removeClass('hide');
        var self = this;
        _.forEach(pageObjects, function (page) {
            if (page.controls.length > 0) {
                hasResults = true;
                // Page Template
                $('#filterResults').append(pageTemplate(page));

                self.generateControls(page.id, page.controls);
            }
        });

        if (!hasResults) {
            $('#filterResults').append('No Results Found');
        }

        $(constants.SELECT_FIELD_LIST_TOGGLE).click((e) => {
            this.showList(e);
        });

        $(constants.SELECT_FIELD_ITEM).click((e) => {
            e.preventDefault();
            var id = e.currentTarget.attributes["data-selected-item"].value;

            if (this.selectedType === 'object') {
                self.selectObject(id);
            }
            if (this.selectedType === 'command') {
                // navigate to instance like current link on left panel, but pass ID of command to select
                try {
                    var instanceId = e.currentTarget.parentNode.parentNode.previousElementSibling.attributes["data-selected-item"].value;
                    self.selectBehaviorInstance(instanceId, id);
                } catch (e) {
                    console.log(e);
                }

            }
        });

        // PF-1222: update button value according to selection
        e.currentTarget.closest('div').querySelector('button').innerHTML = e.currentTarget.innerText+'<span class="caret"></span>';
    }

    generateControls(parentId, controls) {
        var self = this;
        var parentDOMSelector = '#filterResults ul.control-list.' + parentId;
        _.forEach(controls, function (control) {
            control.isGroup = false;
            if (control.controls) {
                $(parentDOMSelector).append(controlWithValuesTemplate(control));
                self.generateControls(control.id, control.controls);
            } else {
                if (control.selectFields && (self.mode !== 'insert' && self.mode !== 'lists')) {
                    $(parentDOMSelector).append(controlWithValuesTemplate(control));
                } else {
                    $(parentDOMSelector).append(controlTemplate(control));
                }
            }

        });
    }

    selectObject(id) {
        $('.controlSelected').removeClass('controlSelected');

        if (listService.mainKind === constants.KIND_MOBILE) {
            this.changePageAndSelectObject(id);
        } else {
            listService.currentId = id;

            if (listService.docType === constants.DOC_TYPE_FORM) {
                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('edit');
                this.changePageAndSelectObject(id);
            } else {
                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('report');
            }
        }
    }

    selectColumn(target, fromTree = true) {
        $('.pfSelected').removeClass('pfSelected');
        $('.controlSelected').removeClass('controlSelected');

        let controlPageId = fromTree ? target.dataset.parentid.substr(6) : listService.currentPageId;
        const currentPage = listService.currentPageId;

        //if pages are different first move to the correct page and then select the control
        if (controlPageId && controlPageId !== currentPage) {

            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            window.setTimeout(() => {
                $(`[data-page='${currentPage}']`).parent().closest('div').removeClass('page-selected');
                $(`[data-page='${controlPageId}']`).parent().closest('div').addClass('page-selected');
                pageSyncService.displayPage(controlPageId);
                eventBus.trigger(constants.EV_CURRENT_COLUMN_VIEW_UPDATED);
                const column = target.dataset.id === 'mobile-column1' ? $('#column1') : $("#column2");
                column.addClass('pfSelected');
                target.classList.add('controlSelected');
                this.addColumnEvents();
                window.setTimeout(() => {
                    spinner.stop();
                }, 10);
            }, 10);
        }
        else {
            const isFirstColumn = (selector) => {
                 return selector === 'mobile-column1' || selector === 'column1';
            };
            const selector = fromTree ? target.dataset.id : target.id;
            const column = isFirstColumn(selector) ? $('#column1') : $("#column2");
            column.addClass('pfSelected');
            //layout
            if (target.tagName.toLowerCase() === 'div') {
                //tree
                const columnSelector = `#${listService.currentPageId}${isFirstColumn(selector) ? '-mobile-column1' : '-mobile-column2'}`;
                $(columnSelector).addClass('controlSelected');
            }
            else {
                target.classList.add('controlSelected');
            }
        }
    }

    changePageAndSelectObject(id) {

        $('.pfSelected').removeClass('pfSelected');

        const currentPage = listService.currentPageId;
        const controlPage = mobileListService.getMobileControl(id);
        const controlPageId = controlPage.model.get('pageId');

        //if pages are different first move to the correct page and then select the control
        if (controlPage && controlPageId !== currentPage) {
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

            window.setTimeout(() => {
                $(`[data-page='${currentPage}']`).parent().closest('div').removeClass('page-selected');
                $(`[data-page='${controlPageId}']`).parent().closest('div').addClass('page-selected');
                pageSyncService.displayPage(controlPageId);
                eventBus.trigger(constants.EV_CURRENT_COLUMN_VIEW_UPDATED);
                pageCaptureController.captureThumbnail();
                eventBus.trigger('selectForm');
                this.addColumnEvents();
                window.setTimeout(() => {
                    spinner.stop();
                }, 10);
            }, 10);
        }

        window.setTimeout(() => {
            let $element = $(`#${id} > div.pf-control-core`);
            if (controlPage && controlPage.model.get('isGroupContainer')) {
                $element = $element.first();
            }

            $element.trigger('click');
        }, 20);
    }


    /*PF-4918: This implementation comes from PF-4918.
    *          It might suffer changes in the future adapted to mobile. Or if no differences,
    *          this can be in a separate file and reused by yoda also.
    *          */
    selectBehaviorInstance(id, selectedCommand = '', objectId = '', behaviorKey = '') {
        //leftPanelState.save();

        let instance = listService.getBehaviorInstance(id);
        if (instance) {
            $('.controlSelected').removeClass('controlSelected');
            if (listService.mainKind === constants.KIND_BEHAVIORS) {
                //eventBus.trigger('behaviorInstanceShow', id);
                let $behaviorSelector = (instance.get('owner') === 'Form')
                    ? $('#behaviors-forms')
                    : $(`#behaviors-page-${listService.currentPageId}`);

                $behaviorSelector.find(`li[data-id="${id}"]`).addClass('controlSelected');
            } else {
                let command = '';
                if (selectedCommand) {
                    command = '/' + selectedCommand;
                }

                // PF-1951 Turning on flag for back-button purposes
                listService.linkClicked = true;
                Backbone.history.loadUrl('behaviors/' + instance.get('ownerId') + '/' + instance.get('behaviorKey') + command);

            }


            const selectedObject = listService.getCanvasObjectById(selectedCommand);
            if (selectedObject) {
                selectedObject.hasBorders = true;
                listService.fcanvas.setActiveObject(selectedObject).renderAll();
                selectedObject.model.set('active', true);
                eventBus.trigger('selectSingleItemFromCanvas');
            }
        } else if (objectId) {
            let control = listService.getObject(objectId);
            if (!control) {
                control = listService.getPage(objectId);
            }

            listService.linkClicked = true;
            Backbone.history.loadUrl(`behaviors/${objectId}/${behaviorKey}`);
            listService.clearSelected();
        }
    }

    showList(e) {
        e.preventDefault();
        var target = e.target.getAttribute('data-target');
        var key = e.target.getAttribute('data-selected-key');
        var targetText = e.target.text.trim();

        if (target) {
            var controlListSelector = '#filterResults' + ' .control-list.' + target;
            var pageListSelector = '#filterResults' + ' .page-list.' + target;
            $(pageListSelector).toggleClass('open-list');
            $(controlListSelector).slideToggle();

            if (this.mode === 'objects' || this.mode === 'print'
                || this.mode === 'instance' || this.mode === 'insertField') {
                this.model.set('selected', { id: listService.getCleanedId(target), name: targetText }, { silent: true });
                $('a.field-select').removeClass('selected');
                $(target).addClass('selected');
                if (this.target === 'command_set_table_rows') {
                    $('button.btn-select-field').button( key !== 'control_table' ? "disable" : "enable");
                } else {
                    $('button.btn-select-field').button("enable");
                }
            }
        }
    }

    viewStateModal(e) {
        e.preventDefault();
        const
            stage = listService.getCurrentStage(),
            role = listService.getCurrentRole(),
            modalSettings = {
                title: 'Object States Overview',
                emptyTitle: 'No objects in a non-mandatory state exist for this stage and role',
                options: constants.STATE_OPTIONS,
                settings: 'state',
                settingsValue: 'value',
                defaultValue: 'default',
                stage: stage,
                role: role,
                model: new Model(),
                filter: (val) => {
                    let controlHasNonDefaultSettings = false;
                    if ((val.model !== undefined && val.model.has('state') && val.model.get('factoryKey')!== 'layout_frame')) {
                        const controlSettings = {
                            stageId: stage,
                            roleId: role,
                            settings: val.model.get('state'),
                            defaultValue: 'default',
                            settingsField: 'value'
                        };
                        controlHasNonDefaultSettings = settingsService.getSetting(controlSettings) !== 'default';
                    }
                    if(val.model.get('factoryKey') === 'control_table'){
                        controlHasNonDefaultSettings=true;
                    }
                    return controlHasNonDefaultSettings;
                }


            };
        const modalView = new InputsByStageAndRole(modalSettings);
        modalView.render();
    }

    viewMandatoryModal(e) {
        e.preventDefault();
        const
            stage = listService.getCurrentStage(),
            role = listService.getCurrentRole(),
            modalSettings = {
                title: 'Mandatory Objects Overview',
                emptyTitle: 'No mandatory objects exist for this stage and role',
                options: constants.MANDATORY_OPTIONS,
                settings: 'mandatories',
                settingsValue: 'required',
                defaultValue: "all",
                stage: stage,
                role: role,
                model: new Model(),
                filter: (val) => {
                    let controlHasNonDefaultSettings = false;
                    if (val.model !== undefined && val.family === 'common_input'){
                        const controlSettings = {
                            stageId: stage,
                            roleId: role,
                            settings: val.model.get('mandatories'),
                            defaultValue: "all",
                            settingsField: 'required'
                        };
                        controlHasNonDefaultSettings = settingsService.getSetting(controlSettings).toLowerCase() === "all" ||
                            settingsService.getSetting(controlSettings).toLowerCase() === "no" ||
                            settingsService.getSetting(controlSettings).toLowerCase() === "yes";
                    }
                    if(val.model.get('factoryKey') === 'control_table'){
                        controlHasNonDefaultSettings=true;
                    }
                    return controlHasNonDefaultSettings;
                }
            };
        const modalView = new InputsByStageAndRole(modalSettings);
        modalView.render();
    }

    updateCurrentStage(e) {
        e.preventDefault();
        const newStage = e.currentTarget.getAttribute('data-stage-id');
        if (newStage) {
            listService.setCurrentStage(newStage);
            eventBus.trigger(constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED);
            this.updateStageAndRoles();
        }
    }

    updateCurrentRole(e) {
        e.preventDefault();
        const newRole = e.currentTarget.getAttribute('data-role-id');
        if (newRole) {
            listService.setCurrentRole(newRole);
            eventBus.trigger(constants.EV_CURRENT_ROLE_OR_STAGE_UPDATED);
            this.updateStageAndRoles();
        }
    }

    updateCurrentColumnView(e){
        e.preventDefault();
        const column = e.currentTarget.getAttribute('data-column-id');
        if (column) {
            mobileListService.mobileCurrentColumnView = column;
            eventBus.trigger(constants.EV_CURRENT_COLUMN_VIEW_UPDATED);
            eventBus.trigger(constants.SET_COLUMNS_TREE);
            this.updateStageAndRoles();
        }
    }

    updatePageObjects(ev, type, objectType, id, name, page, group) {
        const $collapseSwitch = $('#well' + page + ' a[data-target="#objects-page-' + page + '"].switch'),
            self = this,
            instance = listService.getBehaviorInstance(group),
            pageObjectsCount = listService.getPageControls(page).size;

        if (objectType === 'object') {
            eventBus.trigger(constants.EV_VALIDATE_PULSE_ICON_EVENT);

            var badge = $('#well' + page + ' span.badge.object-num');
            var $formBadge = $('#well0').find('span.object-num');
            if (type === 'add') {
                const _newObj = listService.getObject(id);
                const pg = listService.getPage(page);
                const liToAppend = _newObj._groupId ? $("li[data-id='" + _newObj._groupId + "'] > div > ul") : $('#objects-page-' + page + ' > ul');

                if (util.isGroupContainer(_newObj.model.get('factoryKey'))) {
                    $('.controlSelected').removeClass('controlSelected');
                    let element = `<li class="object-selector controlSelected" style="font-weight: bold; white-space: normal" data-id="${id}">
                                        <a class="switch">${name}
                                            <i style="margin-left:5px" role="button" data-toggle="collapse" data-target="#objects-page-group-${id}" class="fa pf-carot-left">
                                             </i>
                                        </a>
                                   </li>`;

                    liToAppend.append(element);
                    
                    setTimeout(() => {
                        thumbPageListUtil.addGroupToThumbItemList(_newObj.model, $("#objects-page-" + page + " ul li[data-id='" + id + "']"), page);
                        this.addSelectorEvents();
                    }, 0);
                } 
                else {
                    if (liToAppend.length) {
                        $('.controlSelected').removeClass('controlSelected');
                    }
                  
                    let element = `<li class="object-selector controlSelected" data-id="${id}">
                                       <a>${name}</a>
                                   </li>`;
                    liToAppend.append(element);
 
                    this.addSelectorEvents();
                }

                if (pg) {
                    this.addSearchableItem('object', id, name, pg.model.get('name') + '/' + name);
                    pageSyncService.addItemToPageCollection({ name: name, link: '', id: id }, pg, objectType);
                    //Updating object's array
                    let filteredPage = this.collection.filter(p => p.get('id') === pg.model.get('id'));
                    //TODO - Page model lose objects list when reopening form and adding a new control to the page, that's why we need to 'fix' this at this point
                    //but we need to find the root cause of this behavior and solve it there instead of fixing it here.
                    const objectsOnPage = listService.getPageControls(pg.model.get('id'));
                    if (objectsOnPage.size !== pg.model.get('objects').length){
                        const _updatedObjects =[ ...objectsOnPage.values() ];
                        pg.model.set('objects', _updatedObjects, {silent:true});
                    }

                    filteredPage[0].set('objects', pg.model.get('objects'), {silent:true});
                    filteredPage[0].set('objectCount', pg.model.get('objectCount'), {silent:true});
                }
            } else {
                const childElements = $("#objects-page-" + page + " ul li[data-id='" + id + "'] ul").first().children('li');
                if (childElements.length > 0) {
                    const parent = $("#objects-page-" + page + " ul li[data-id='" + id + "']").parent();
                    let isUndo = false;
                    $.each(childElements, (idx, childElement) => { //Check if child elements still exist, if true then it is an undo operation
                        if ($(childElement).data('id') && listService.getObject($(childElement).data('id'))) {
                            isUndo = true;
                            return;
                        }
                    });
                    if (isUndo) {
                        parent.append(childElements);
                    }
                }

                let obj = $('#objects-page-' + page + ' ul li[data-id="' + id + '"]');
                // must detect that it existed under the Page - Objects.
                if (obj) {
                    $(obj).remove();
                    this.removeSearchableItem(id);
                    const pg = listService.getPage(page);
                    pageSyncService.removeItemFromPageCollection(id, pg, objectType);
                    //Updating behaviors's array
                    let filteredPage = this.collection.filter(p => p.get('id') === pg.model.get('id'));
                    filteredPage[0].set('behaviors', pg.model.get('behaviors'), { silent: true });
                    filteredPage[0].set('behaviorCount', pg.model.get('behaviorCount'), { silent: true });
                }
                this.addSelectorEvents();
            }

            
            // update count
            $(badge[0]).text(pageObjectsCount);
            if (pageObjectsCount) {
                $(badge[0]).show();
                $collapseSwitch.removeClass('hide');
            } else {
                $(badge[0]).hide();
                $collapseSwitch.addClass('hide');
            }

            // update global count
            $formBadge.text(Number(listService.objectCount - 1)); //The -1 is needed because the Form is also counted on listService.objectCount but it should not be counted in global count
            if (Number(listService.objectCount - 1)) {
                $formBadge.show();
            } else {
                $formBadge.hide();
            }
        } else {
            if(instance && instance.get('owner') === 'Form'){
                var badge = $('#well0 span.badge.behavior-num');
            }else{
                var badge = $('#well' + page + ' span.badge.behavior-num');
            }
            
            var count = $(badge[0]).text();

            if (type === 'add') {
                if(instance.get('owner') === 'Form'){
                   $('#behaviors-forms ul').append('<li class="behavior-selector" data-id="' + id + '"><a>' + name + '</a></li>');
                }else{
                   $('#behaviors-page-' + page + ' ul').append('<li class="behavior-selector" data-id="' + id + '"><a>' + name + '</a></li>');
                }
                count++;

                const pg = listService.getPage(page);
                if(instance.get('owner') === 'Form'){
                    this.addSearchableItem('behaviors', id, name, 'Form/' + name);
                }else{
                    this.addSearchableItem('behaviors', id, name, pg.model.get('name') + '/' + name);
                }                
               
                //Checking is a form behavior
                if(instance.get('owner') === 'Form'){
                     this.addItemToFormCollection({name: name, link: '', id: id}, objectType);
                }else{
                     pageSyncService.addItemToPageCollection({name: name, link: '', id: id}, pg, objectType);
                }

            } else if (type === 'update') {
                let element='';
                if(instance.get('owner') === 'Form'){
                    element = $('#behaviors-forms ul li[data-id="' + id + '"] a');
                }else{
                    element = $('#behaviors-page-' + page + ' ul li[data-id="' + id + '"] a');
                }

                if(element.length>0){
                    element[0].innerText = name;
                }
            } else {
                var obj = $('#behaviors-page-' + page + ' ul li[data-id="' + id + '"]');
                // must detect that it existed under the Page - Objects.
                if (obj) {
                    $(obj).remove();
                    count--;
                    this.removeSearchableItem(id);
                    const pg = listService.getPage(page);
                    pageSyncService.removeItemFromPageCollection(id, pg, objectType)
                }
            }

            // update count
            $(badge[0]).text(count);

            // hide/show the collapse switch
            if (pageObjectsCount > 0) {
                $collapseSwitch.removeClass('hide');
            } else {
                $collapseSwitch.addClass('hide');
            }

            if (count > 0) {
                if(instance.get('owner') === 'Form'){
                    $('#well0 a[data-target="#behaviors-forms"].switch').removeClass('hide');
                }else{
                   $('#well' + page + ' a[data-target="#behaviors-page-' + page + '"].switch').removeClass('hide');
                }
                
            } else {
                if(instance.get('owner') === ''){
                   $('#well0 a[data-target="#behaviors-forms"].switch').addClass('hide');
                }else{
                   $('#well' + page + ' a[data-target="#behaviors-page-' + page + '"].switch').addClass('hide');
                }
                
            }

            $('li.behavior-selector').off('click').on('click',  (ev)=> {
                var id = ev.currentTarget.attributes["data-id"].value;
                this.selectBehaviorInstance(id);
            });

        }
    }

    updatePageCommands(ev, type, objectType, id, name, page, instanceId) {
        if (type === 'add') {
            this.addSearchableItem(objectType, id, name, page + '/' + name, instanceId);
        } else {
            this.removeSearchableItem(id);
        }
    }

    setUndoRedoAccess() {
        $('#designerUndo').removeClass('disabled pf-disable');
        $('#designerRedo').removeClass('disabled pf-disable');

        if (!undoService.hasUndo()) {
            $('#designerUndo').addClass('disabled pf-disable');
        }

        if (!undoService.hasRedo()) {
            $('#designerRedo').addClass('disabled pf-disable');
        }

    }

    //========================================================================================================
    // 1. Identify page DOM ID corresponding to the clicked thumbnail.
    // 2. Clear the selected thumbnail by clearing selection of all of thumbnails.
    // 3. Select the clicked thumbnail.
    // 4. Call service to remove visible DOM controls, then populate layout with controls of chosen page.
    //========================================================================================================
    thumbnailClickListener(evt, force) {

        if (evt.target.tagName.toLowerCase() === 'i') {
            return;
        }

        let target = evt.target.classList.contains('document-title') ? evt.target : evt.currentTarget.getElementsByClassName('document-title')[0];

        // PF-3995: Let the event fall through and skip all code below


        if (!mobileListService.wantsToAddMoreObjects && evt.target &&
            ( target.tagName === 'I' || (target.tagName === 'A' && $(target).hasClass('switch'))) ||
            ($(evt.target).hasClass('not-page') || $(evt.target).parents().hasClass('not-page'))
            ) {
            return;
        }

        let localForce = false;
        mobileListService.wantsToAddMoreObjects = false;

        
        // 1. Identify the thumbnail container for this page group.
        //   - Either the empty div parent suffered the click, or the injected child canvas got the click
        //   - We accept the canvas as being optional; it may not have yet been captured from a page.
        //   - We used that parent DIV's IDto get its data-page attribute
        var clickedId = target.id ? target.id : target.parentElement.id;
        var selectedElement = target;

        if (target.id) {
            clickedId = target.id;
            selectedElement = target.parentElement;
        } else if (target.classList.contains('document-heading')) {
            clickedId = target.children[1].id;
            selectedElement = target;
        } else if (target.parentElement.parentElement.children[1]) {
            clickedId = target.parentElement.parentElement.children[1].id;
            selectedElement = target.parentElement.parentElement;
            // PF-2353: to prevent a bug where the "last" behaviors icon is used and we attempt to return to the previous page active
            // full testing scenario in the Jira tkt
            localForce = true;
        }

        // 2. Identify. Assumes DOM element holds pageID in value of attribute 'data-page'
        let pageId = $(constants.ID_SEL + clickedId).attr('data-page');
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        // Run the operation on next browser turn to let spinner render
        window.setTimeout(() => {
            // 3. Clear selection on all thumbnails
            $('#thumb-pages .document-heading').removeClass('page-selected');

            $(`${constants.CLASS_SEL}${'tn-target'}`).removeClass('page-selected');

            // 3.1 if the event comes from behaviors->layout views, we need to grab the element
            if ( listService.currentForm.model.get('restorePageClicked') ) {
                selectedElement = $(`#tn-pg-${listService.currentForm.model.get('restorePageClicked')}`)[0].querySelector('div.document-heading');
            }

            // 4. ... but select clicked thumbnail image :-)
            $(selectedElement).addClass('page-selected');

            if (listService.currentPageId !== pageId || force || localForce) {

                if ( listService.currentForm.model.get('restorePageClicked') ) {
                    pageId = listService.currentForm.model.get('restorePageClicked');
                    listService.currentPageId = pageId;
                    listService.currentForm.model.set('restorePageClicked', null, SILENT);
                }
                // 5. Clear layout DOM, add this page into layout DOM
                pageSyncService.displayPage(pageId);
                eventBus.trigger(constants.EV_CURRENT_COLUMN_VIEW_UPDATED);
                this.addColumnEvents();
                // #PF-2353 When a page link is clicked and user is inside behaiors view, it needs to be redirected to edit layout view
                // replicating behavior from flash app
                if (listService.mainKind === constants.KIND_BEHAVIORS || listService.mainKind === constants.KIND_WORKFLOW) {
                    listService.currentForm.model.set('restorePageClicked', pageId, SILENT);

                    // #PF-1951 Turning on flag for back-button purposes
                    listService.linkClicked = true;
                    Backbone.history.loadUrl('edit');
                }

                // 6. Capture the page to a thumbnail
                pageCaptureController.captureThumbnail();

                eventBus.trigger('selectForm');
                
            }

            window.setTimeout(() => {
                spinner.stop();
                mobileListService.mobilePageSelected = target.dataset.page;

                let isPageEmpty = () => {
                    let sections = listService.getSectionsByPageId(mobileListService.mobilePageSelected);
                    let controls = listService.mobileObjectsByPageId(mobileListService.mobilePageSelected).filter(control => !!control.sectionId);

                    return (sections && (!sections.size || (sections.size && !controls.size)));
                }

                if (target.dataset && target.dataset.page && isPageEmpty() && this.triggerDialog) {
                    let simpleModal = new SimpleConfirmModal({
                        model: new Model({
                            subtitle: constants.MOBILE_DIALOG_TITLE,
                            confirmationText: constants.ADD_OBJECTS_FORM,
                            height: 150,
                            width: 400
                        })
                    });
                    mobileListService.wantsToAddMoreObjects = false;
                    simpleModal.render().then((result) => {
                        if (result === 'Ok') {
                            mobileListService.wantsToAddMoreObjects = true;
                            document.getElementById('openMobileWizard').click();
                        }
                    }).catch((err)=> {
                        console.log('Error Opening Wizard ', err);
                        NotificationService.error('Error Opening Wizard ' + err.MESSAGE);
                    });
                }
            }, 10);

        }, 10);
    }

    addSelectorEvents() {
        let objectSelector = $('#mo-objects-tree').find('li.object-selector');
        let objectSelectorLink = $('#mo-objects-tree').find('li.object-selector > a > span');
        let behaviorSelector = $('#mo-objects-tree').find('li.behavior-selector');

        let objectHandler = (ev) => {
            ev.stopPropagation();

            const target = $(ev.target).is('li') ? ev.target : $(ev.target).closest('li')[0];
            let id = target.attributes["data-id"].value;

            if (!id) {
                return;
            }

            //If the user did not click the arrow only select the element
            if (!$(ev.target).hasClass('pf-carot-left') && !$(ev.target).hasClass('pf-carot-down')) {
                const _obj = mobileListService.getMobileControl(id);

                if (_obj && util.isGroupContainer(_obj.model.get('factoryKey')) && ($(target).hasClass('pf-carot-left') || $(target).hasClass('pf-carot-down'))){
                    $('#objects-page-group-' + id).toggleClass('in');
                    $("#objects-page-" + _obj.model.get('pageId') + " ul li[data-id='" + id + "'] > a > i").toggleClass('pf-carot-left pf-carot-down');
                }
    
                if (!$(target).hasClass('pf-carot-left') && !$(target).hasClass('pf-carot-down')) {
                    if (id === 'mobile-column1' || id === 'mobile-column2' ) {
                        this.selectColumn(target);
                    }
                    else {
                        this.selectObject(id);
                    }
                }
            }
            else{
                const target = $(ev.target.parentElement);
                const panel = $(target.data().target);
                const icon = $(ev.target);
                const collapsedIcon = 'pf-carot-left pf-rotate-icon';

                panel.collapse('toggle');
                util.togglePanel(target, icon, collapsedIcon);
            }
            //const _obj = listService.getObject(id);
        };

        let behaviorHandler = (ev) => {
            ev.stopPropagation();
            let target = ev.currentTarget;
            if (!target.attributes["data-id"]) {
                return false;
            }

            let id = target.attributes["data-id"].value;
            let objId = target.attributes["data-objectid"].value,
                behaviorKey = target.attributes["data-behaviorkey"].value;
            this.selectBehaviorInstance(id, '', objId, behaviorKey);
        };

        objectSelector.off('click').on('click', objectHandler);
        objectSelectorLink.off('click').on('click', objectHandler);
        behaviorSelector.off('click').on('click', behaviorHandler);
        this.addColumnEvents();
    }

    addColumnEvents() {
        setTimeout(() => {
            let columnClickHandler = (event) => {
                const target = event.target;

                const isColumn = (id) => {
                    return id === 'column1' || id === 'column2';
                }

                const isTargetColumn =  isColumn(target.id);
                const isParentColumn = isColumn(target.parentElement.id);

                if (isTargetColumn || isParentColumn) {
                    const which = isTargetColumn ? target : target.parentElement;
                    this.selectColumn(which, false);
                }
            };

            $('#column1').off('click').on('click', columnClickHandler);
            $('#column2').off('click').on('click', columnClickHandler);
        }, 100)
    }

    getCurrentRoleName() {
        const
            role = listService.getWorkflowRole(listService.getCurrentRole()),
            roleName = role ? role.name : 'All';
        return roleName;
    }

    getCurrentStageName() {
        const
            stage = listService.getWorkflowStage(listService.getCurrentStage()),
            stageName = stage ? stage.model.get('name') : 'All';
        return stageName;
    }

    getViewValues() {
        const formBehaviorsObj = listService.getBehaviorFormTotals();
        const columns = [{name:constants.ONE_COLUMN_VIEW_DROPDOWN_TEXT},{name:constants.TWO_COLUMN_VIEW_DROPDOWN_TEXT}];

        return _.merge(this.model.toJSON(), {
            stages:listService.getWorkflowStages(true, true),
            roles:listService.getWorkflowRoles(true, true),
            currentRole:this.getCurrentRoleName(),
            currentStage: this.getCurrentStageName(),
            currentColumn: mobileListService.mobileCurrentColumnView,
            columns: columns,
            behaviors: formBehaviorsObj.behaviors,
            objects: listService.currentForm ? listService.currentForm.model.attributes.objects : [],
            behaviorCount: formBehaviorsObj.size,
            objectCount: listService.currentForm ? listService.currentForm.model.attributes.objectCount : 0
        });
    }
    
    updateStageAndRoles(model) {

        const values = model || this.getViewValues();

        $('#stagesDropdown').empty();
        $('#stagesDropdown').append(stageDropdown(values));

        $('#rolesDropdown').empty();
        $('#rolesDropdown').append(rolesDropdown(values));

        $('#columnsDropdown').empty();
        $('#columnsDropdown').append(columnsDropdown(values));
    }

    searchItemMatcher() {
        let that = this;
        return function findMatches(q, cb) {
            var matches, substringRegex;

            matches = [];

            substringRegex = new RegExp(q, 'i');

            $.each(that.searchableItems, function (i, searchableItem) {
                if (substringRegex.test(searchableItem.name) || substringRegex.test(searchableItem.caption)) {
                    matches.push(searchableItem);
                }
            });
            cb(matches);
        };
    }

    addSearchableItem(type, id, name, displayName, instanceId = '') {
        this.searchableItems.push({
            id: id,
            type: type,
            name: name,
            icon: '',
            displayName: displayName,
            instanceId: instanceId
        });
    }

    removeSearchableItem(id) {
        const index = this.searchableItems.findIndex(item => item.id === id);
        this.searchableItems.splice(index, 1);
    }

    addItemToFormCollection(item, collectionType) {
        // object or behaviors
        switch (collectionType) {
            case 'object':
                //this.model.get('formObjects').push(item);
                //this.model.attributes.formObjectCount++;
                break;
            case 'behaviors':
                listService.currentForm.model.get('behaviors').push(item);
                listService.currentForm.model.attributes.behaviorCount++;

                //this.model.get('formBehaviors').push(item);
                //this.model.attributes.formBehaviorCount++;
                break;
        }
     }

    handleDocumentSwitch(event) {
        let target = event.currentTarget;

        if (target.tagName.toLowerCase() === 'div') {
            target = $(target).find('a.switch')[0];
        }
        
        let state = {
            target: target.dataset.target,
            open: target.classList.contains("collapsed"),
            type: 'document-branch'
        };

        mobileListService.addTreeState(state.target, state);

        //$(target).find('i').toggleClass('pf-carot-down pf-carot-left');
       
        const icon = $(target).find('i');
        thumbPageListUtil.togglePanel($(target), $(target).find('i'), collapsedIcon);

        console.log("state", mobileListService.mobileTreeState.toArray());
    }

    refreshSearchableItems() {
        this.searchableItems = listService.getSearchableItems();
    }

    styleForBadge(i) {
        return i > 0 ? 'inline-block' : 'none';
    }

    openBehaviorsOnly(){
        const page = listService.getPage(listService.currentPageId);
        thumbPageListUtil.updateBehaviorsOnly(page.id);
        LeftPanelStateService.save();    
    }

    createPageTab(id) {
        let totalObjects = 0;
        const page = this.collection.models.filter(c => c.id === id);
        if (page.length > 0) {
            let behaviorsObj = listService.getBehaviorTotals(page[0].get('id'));
            const objCount = listService.getPageControls(page[0].get('id')).size;
            page[0].set('behaviorCount', behaviorsObj.size, SILENT);
            page[0].set('objectCount', objCount, SILENT);
            page[0].set('behaviors', behaviorsObj.behaviors, SILENT);

            totalObjects += objCount;

            new ThumbPageView({ model: page[0], el: constants.THUMBPAGES_ID }).render();
            new ThumbPageBehaviorsOnlyView({ model: page[0], el: constants.THUMBPAGESBO_ID, behaviorsOnly: true }).render();

            thumbPageListUtil.updateBehaviorsOnly(page[0].id);
        }

        return totalObjects;
    }

    activateWidgets() {
        this.model.set('docType', listService.mainKind === constants.KIND_REPORT ? 'Report' : 'Form', SILENT);
        this.searchableItems = listService.getSearchableItems();
        const values = this.getViewValues();


        this.$el.empty();
        this.$el.html(template(values));
        this.updateStageAndRoles(values);
        this.initBreadcrumb();

        try {
            let totalObjects = 0;

            this.searchableItems.forEach(model=>{
                totalObjects += this.createPageTab(model.id);
            });

            $('#behaviorsonly-tab').on('click', (ev) => {

                let hasBehaviors = listService.behaviorCommands.size;
              
                if(!hasBehaviors){
                    ev.preventDefault();
                    notificationService.info("Please add behaviors before using the Behaviors Only tab.");
                    return false;
                }
                    
            });

            const $well0 = $('#well0').find('span.object-num');
            $well0.text(totalObjects);
            if (totalObjects) {
                $well0.show();
            }
        } catch (err) {
            console.log(`ERROR. ThumbPageView.render issue`, err);
        }

        if ((constants.KIND_LAYOUT + constants.KIND_REPORT + constants.KIND_MOBILE).includes(listService.mainKind)) {
            // Ensure current page always selected
            let page = listService.pageList.find(page => mobileListService.pageHasSections(page.id));

            if(page){
                listService.currentPageId = page.id;
            }              
        }

        setTimeout(() => { 
            this.addSelectorEvents(); 
        }, 0);

        $('#searchLeftPanel').typeahead({
                hint: true,
                highlight: true,
                minlength: 3
            },
            {
                name: 'searchableItems',
                display: 'name',
                source: this.searchItemMatcher(),
                templates: {
                    empty: [
                        '<div class="empty-search" style="font-size: 11px;">',
                        'unable to find any results that match',
                        '</div>'
                    ].join('\n'),
                    suggestion: _.template('<div data-type="<%=type%>" data-id="<%=id%>" data-instance-id="<%=instanceId%>" draggable="true" class="search-item"><i style="font-size: 24px; font-size: 2.4rem;" class="fa <%=icon%>"></i><div class="search-results-ellipsis"><strong><%=displayName%></strong></div></div>')
                }
            });

        $('.twitter-typeahead').css('display', 'block');

        $('#searchLeftPanel').off('typeahead:selected').on('typeahead:selected', (obj, data, name) => {
            $('#thumb-pages').find('.collapse').collapse('hide');

            listService.itemSearched = data.id;
            if (data.type === 'object') {
                this.selectObject(data.id);
            } else if (data.type === 'stage') {
                listService.linkClicked = true;
                Backbone.history.loadUrl('workflowmain');

                const selectedObject = listService.getCanvasObjectById(data.id);
                if (selectedObject) {
                    listService.fcanvas.setActiveObject(selectedObject).renderAll();
                }
            } else if (data.type === 'page') {
                listService.itemSearched = 0;
                listService.linkClicked = true;
                pageSyncService.displayPage(data.id);
                Backbone.history.loadUrl('edit');
            } else if (data.type === 'command') {
                this.selectBehaviorInstance(data.instanceId, data.id);
            }

            $('#searchLeftPanel').typeahead('val', '');
        });

        MobileLeftPanelButton.render('sectionsLeftPanel');
    }

    togglePageSection() {
            /*TODO: PF-3890. I willm remove this, once I am sure I am not gonna need it.*/

        /*$('ul.column-options li.object-selector .switch').off('click').on('click', (ev)=> {

            ev && ev.stopPropagation();

            let toggleLink = ev.currentTarget;
            let elementClicked = ev.target.tagName;
            if (elementClicked !== 'SPAN') {
                this.handleDocumentSwitch(ev);
                $(toggleLink.dataset.target).toggle( "slow", function() {
                    // Animation complete.
                });
            }
        });*/
    }

    updateFormBehaviors() {
        const factoryKey = this.model.get('isForm')? 'layout_frame' : 'reports_frame';
        let page = 'aform';
        let behaviors = thumbPageListUtil.getBehaviorsListForControl(factoryKey, page);
        const newUlTree = $('#behavior-mobile-form ul');

        newUlTree.empty();
        let elements = '';
        // behaviors && behaviors.forEach(behavior => {
        //     let properties = `data-id="${behavior.id}" data-behaviorkey="${behavior.behaviorKey}" data-objectid="${behavior.objectId}"`;
        //     elements += `<li class="behavior-options behavior-selector form-behavior" ${properties}>
        //                       <a class="${behavior.active}">${behavior.text}</a>
        //                  </li>`;
        // });

        newUlTree.append(behaviors);
    }

    setTreeBranchesStatus() {
        let branchSelector = (branchType = 'document-branch') => {
            let treeState = mobileListService.mobileTreeState.filter(branch => branch.type === branchType);
            let selector = branchType === 'document-branch' ?
                    '.document-heading a[data-target="$target"]' :
                                    '.document-items a[data-target="$target"]';
            treeState && treeState.forEach(branch => {
                let leftBranch =  document.querySelector(selector.replace("$target", branch.target));
                if (branch.open && leftBranch) {
                    leftBranch.click();
                }
            });
        }

        branchSelector('object-branch');
        setTimeout(() => {
            branchSelector();
            this.triggerDialog = true;
        }, 100);
    }

    createDraggableSections() {
        let that = this;
        let placeholderHeight,
        placeholderAnimatorHeight;
        setTimeout(function () {
            $('.mobile-column-content').sortable({
                connectWith: ".mobile-column-content",
                placeholder: 'slide-placeholder',
                axis: "y",
                revert: 150,
                contaiment: "#mobile-columns-wrapper",
                start: function (event, ui) {

                    placeholderHeight = ui.item.outerHeight();
                    ui.placeholder.height(placeholderHeight);
                    $('<div class="slide-placeholder-animator" data-height="' + placeholderHeight + '"></div>').insertAfter(ui.placeholder);
                    const item = ui.item[0];

                    const layer = document.createElement('div');

                    layer.id = 'itemLayer';
                    layer.style.height = placeholderHeight + 'px';

                    layer.style.backgroundColor = 'white';
                    layer.style.position = 'absolute';
                    layer.style.zIndex = '99999';
                    item.style.height = placeholderHeight +'px';
                    item.appendChild(layer);

                    if (item.parentElement.id === "column2-content" && $('#column1-content').children('.pf-section-control').length === 1) {
                        $('#column1-content').children('.pf-section-control').removeClass('disabled');
                    }
                },
                cancel:".disabled, .pf-control.pf-editable",

                change: function(event, ui) {

                    ui.placeholder.stop().height(0).animate({
                        height: ui.item.outerHeight() + 15
                    }, 300);

                    placeholderAnimatorHeight = parseInt($(".slide-placeholder-animator").attr("data-height"));

                    $(".slide-placeholder-animator").stop().height(placeholderAnimatorHeight + 15).animate({
                        height: 0
                    }, 300, function() {
                        $(this).remove();
                        placeholderHeight = ui.item.outerHeight();
                        $('<div class="slide-placeholder-animator" data-height="' + placeholderHeight + '"></div>').insertAfter(ui.placeholder);
                    });

                },

                stop: function (event, ui) {

                    $(".slide-placeholder-animator").remove();

                    const mapChildren = (children) => {
                        return Array.from(children)
                            .map((section, index) => {
                                return {
                                    id: section.id,
                                    index: index
                            };
                        });
                    };

                    ui.item[0].removeChild(document.getElementById('itemLayer'));

                    const section = listService.getSectionById(ui.item[0].id);
                    const page = listService.getPage(section.first().pageId);

                    if (mobileListService.mobileCurrentColumnView === constants.ONE_COLUMN_VIEW_DROPDOWN_TEXT) {
                        mobileListService.reorderSections(page.id, mapChildren(event.target.children));
                        mobileListService.reorderTwoColumnsSections(mapChildren(event.target.children), page.id, 0);
                    }
                    else {
                        const column1 = $('#column1-content');
                        const column2 = $('#column2-content');
                        if (event.target.id === "column2-content") {
                            if (column2.children('.pf-control').length === 0) {
                                const confirmationText = mobileConstants.MOBILE_WARNING_RESET_COLUMNS.replace( /{Page name}/gi , page.model.get('name'));
                                let simpleModal = new SimpleConfirmModal({
                                    model: new Model({
                                        subtitle: "Reset Columns",
                                        confirmationText: confirmationText,
                                        height: 150,
                                        width: 500
                                    })
                                });

                                simpleModal.render().then((result) => {
                                    if (result === 'Ok') {
                                        listService.resetColumnsStepThree(page.id);

                                        listService.linkClicked = true;
                                        Backbone.history.loadUrl('mobile');
                                        eventBus.trigger('changeMobileLayout');
                                        that.display2ndColumnPlaceholder();
                                    }
                                }).catch((err)=> {
                                    console.log('Error RESETTING COLUMNS', err);
                                    NotificationService.error('Error RESETTING COLUMNS ' + err.MESSAGE);
                                });

                                return false;
                            }
                        }else{                        
                            that.display2ndColumnPlaceholder();
                        }

                        mobileListService.reorderTwoColumnsSections(mapChildren(column1.children()), page.id, 1);
                        mobileListService.reorderTwoColumnsSections(mapChildren(column2.children('.pf-control.pf-selectable')), page.id, 2);
                    }

                    eventBus.trigger(constants.SET_COLUMNS_TREE, page.id);
                    //Click on the selected section
                    $(`#${section.first().id} > div.pf-control-core`).click();
                    let children = $('#column1-content').children('.pf-section-control');
                    if (children.length === 1) {
                       children.addClass('disabled');
                    }
                }
            });

            $( ".mobile-column-content" ).disableSelection();

            let children = $('#column1-content').children('.pf-section-control');
            if (children.length === 1) {
                children.addClass('disabled');
            } 
        }, 0);
    }

    createDraggableMobileControls() {

        const lastControlInSectionInColumnOne = (event, ui) => {
            const lastSectionContent = $('#column1-content').children(':last').find('.pf-control.pf-editable');
            if (lastSectionContent.length === 2) {
                lastSectionContent.toArray().forEach(control => { if (control.id !== ui.item.id){ control.classList.add('disabled')}});
            }
        };

        const showModalWarning = (lastSectionId) => {
            const section = listService.getSectionById(lastSectionId);
            const page = listService.getPage(section.first().pageId);
            const confirmationText = mobileConstants.MOBILE_WARNING_RESET_COLUMNS.replace( /{Page name}/gi , page.model.get('name'));
            let simpleModal = new SimpleConfirmModal({
                model: new Model({
                    subtitle: "Reset Columns",
                    confirmationText: confirmationText,
                    height: 150,
                    width: 500
                })
            });

            simpleModal.render().then((result) => {
                if (result === 'Ok') {
                    listService.resetColumnsStepThree(page.id);

                    listService.linkClicked = true;
                    Backbone.history.loadUrl('mobile');
                    eventBus.trigger('changeMobileLayout');
                }
            }).catch((err)=> {
                console.log('Error RESETTING COLUMNS by moving last control on column two.', err);
                NotificationService.error('Error RESETTING COLUMNS by moving last control on column two.' + err.MESSAGE);
            });
            return false;
        };

        const isLastSectionInColumnTwo = (event, ui) => {
            if (1 === $('#column2-content').children('.pf-control.pf-selectable').length) {
                const lastSectionId = $('#column2-content').children('.pf-control.pf-selectable:last').attr('id');
                const sectionItems = $('#column2-content').children('.pf-control.pf-selectable:last');
                const sectionId = event.target.id;
                if (lastSectionId  === sectionId && sectionItems.length === 1) {
                    return true;
                }
            }

        };

        const emptySection = (event) => {
            const sectionId = event.target.id;
            const sectionContent = $(`#sectionBodyContainer_${event.target.id}`).children('.pf-control.pf-editable');
            const hideIconExist = $(`#sectionHeaderContainer_${event.target.id}`).children('#empty-section-badge');
            if (!sectionContent.length && !hideIconExist.length) {
                const hideIcon = `<div id="empty-section-badge" 
                                       class="mobile-badge-background" 
                                       style="display: flex;
                                       float: right; ">${mobileConstants.BADGES.get('hidden')}</div>`;
                $(`#sectionHeaderContainer_${sectionId}`).append(hideIcon);
            }
        };

        const removeHideIcon = (event) => {
            const hideIcon = event.target.querySelector('#empty-section-badge');
            if (hideIcon) { hideIcon.remove() }
        };

        const updateDroppedControlInSection = (event) => {
            const controls = $(`#sectionBodyContainer_${event.target.id}`).children('.pf-control.pf-editable');
            const sectionId = event.target.id;
            Array.from(controls).forEach((child, index) => {
                const mobileObject = listService.getMobileObject(child.id);
                mobileObject.order = index + 1;
                mobileObject.sectionId = sectionId;
                listService.updateMobileObject(mobileObject.id, mobileObject);
            });
        };


        setTimeout(function () { // setTimeout - requires the dom be fully load. TODO: find better approach to solve this.
            let adjustment;
            $('.pf-section-control').sortable({
                connectWith: ".pf-section-control",
                containment: "#mobile-columns-wrapper",
                placeholder: {
                    element: function(currentItem) {
                        return $("<div class='mobile-control-placeholder'/>")[0];
                    },
                    update: function(container, p) {
                        return;
                    }
                },
                cursorAt: { top: 5},
                tolerance: "pointer",
                dropOnEmpty: true,
                items: '.pf-section-control.pf-control.pf-selectable',
                cancel:".disabled",
                start: function(event, ui) {
                    lastControlInSectionInColumnOne(event, ui);
                    if(isLastSectionInColumnTwo(event)){
                        $(this).sortable('cancel');
                        showModalWarning(event.target.id);
                        event.dataTransfer.effectAllowed = "move";
                    }
                },
                remove: function(event, ui) {
                    emptySection(event);
                    that.display2ndColumnPlaceholder();
                },
                stop: function(event, ui) {
                    updateDroppedControlInSection(event);
                },
                receive: function(event, ui) {
                    $(`#sectionBodyContainer_${event.target.id}`).append(ui.item);
                    if (event.target.id === $('#column1-content').children(':last').attr('id')) {
                        $('#column1-content').children(':last').find('.pf-control.pf-selectable').removeClass('disabled');
                    } else {
                        ui.item.removeClass('disabled');
                    }
                    updateDroppedControlInSection(event);
                    removeHideIcon(event);
                    that.display2ndColumnPlaceholder();
                }
            });
            $(".pf-section-control").disableSelection();
        }, 0);
    }    

    display2ndColumnPlaceholder(){
        let _display = $('#column2-content').children('.pf-section-control').length === 0 ? 'inline-block' : 'none';
        $('#columnsPlaceholder').css('display',  _display);
    }

    //========================================================================================================
    // Populate the thumbnail pane by rendering the collection of thumbnail models.
    // Select current page's thumbnail.
    //========================================================================================================
    render() {
        LeftPanelStateService.resetTree();
        listService.firstLoad = true;
        this.activateWidgets();
        this.delegateEvents();
        this.updateFormBehaviors();
        this.togglePageSection();
        this.triggerDialog = false;
        this.setTreeBranchesStatus();
        // PF-2613 -- cause conditional scrollbar if thumbnail item list height exceeds vertical viewport
        $(window).trigger('resize');

        return this;
    }
}

export default MobileThumbPageListView;
